export class LimitSelect {
    /**
     * The element to listen for changes
     *
     * @protected
     */
    protected element: HTMLSelectElement;

    /**
     * The element to scroll to after the limit was changed
     *
     * @protected
     */
    protected scrollTo: string = '';

    constructor(element: HTMLSelectElement) {
        this.element = element;
        this.scrollTo = this.element.dataset.scrollTo;

        this.element.addEventListener('change', this.changeListener, {passive: true})
        this.setValueFromUri();
        this.pagination();
    }

    /**
     * Initialization
     */
    protected setValueFromUri = () => {
        const url = new URL(window.location.toString());
        this.element.value = url.searchParams.get('limit') ?? 'all';
    }

    /**
     * Shows the pagination if it has child items
     */
    protected pagination = () => {
        const pagination: HTMLElement = document.querySelector('.pagination');

        if (pagination) {
            const paginationList: HTMLUListElement = pagination.querySelector('ul');

            if (paginationList && paginationList.childElementCount > 0 && this.element.value != 'all') {
                pagination.classList.remove('d-none');
            }
        }
    }

    /**
     * Change handler function if the value of the element was changed
     */
    protected changeListener = () => {
        let firstPage = window.location.toString();

        if (this.element.value === 'all') {
            firstPage = window.location.origin + window.location.pathname;
            firstPage = firstPage.replace(new RegExp('~p[0-9]{0,10}'), '~p1');
        }

        const uri = new URL(firstPage);

        if (this.scrollTo) {
            uri.hash = this.scrollTo;
        }

        uri.searchParams.set('limit', this.element.value);

        window.location.replace(uri);
    }

    /**
     * Create LimitSelect-Instances from a NodeList of HTMLSelectElements
     *
     * @param {NodeListOf<HTMLSelectElement>|string} elementList
     */
    static createInstances = (elementList:NodeListOf<HTMLSelectElement>|string) => {
        if (typeof elementList === 'string') {
            elementList = document.querySelectorAll(elementList);
        }

        if (elementList.length > 0) {
            Array.from(elementList).forEach((el) => {
                new LimitSelect(el);
            });
        }
    }
}

/**
 * Initialize limitSelect
 */
export function initLimitSelect() {
    LimitSelect.createInstances('select.limit-select');
}
